/*----------------------------------------
 auth functions */
import constants from 'lib/constants';
import Cookies from 'cookies-js';
import LocalStorage from 'lib/local-storage';
import SessionStorage from 'lib/session-storage';

function isFeatureFlagEnabled(featureId) {
	var featureFlags = window.lt && window.lt.features && window.lt.features ? window.lt.features : {};
	return featureFlags.some(e => e.featureId === featureId && e.enabled === true) ? true : false;
}

function setCorrectSsoIdProp(data) {
	data.ssoid = data.ssoId;
}

function invalidateSessions() {
	// remove existing login token and sso from users cookies
	Cookies.expire(constants.cookieLtSession);
	Cookies.expire(constants.cookieProfileToken);
	Cookies.expire(constants.cookieSsoId);
	Cookies.expire(constants.cookieSsoCreated);
	Cookies.expire(constants.cookieAemToken);
	Cookies.expire(constants.cookieSpabizToken);
	Cookies.expire(constants.cookieLtAuthorization);
	Cookies.expire(constants.cookieLtAuthorizationV2);
	Cookies.expire(constants.cookieLtAuthentication);
	// remove member details from storage
	SessionStorage.remove(constants.memberDetailsStorageKey);
	// remove reactivation information from storage
	SessionStorage.remove(constants.studentReactivationAlertEligible);
	SessionStorage.remove(constants.dismissedStudentReactivateNotification);
	SessionStorage.remove(constants.onHoldReactivationAlertEligible);
	SessionStorage.remove(constants.dismissedOnHoldReactivateNotification);
	SessionStorage.remove(constants.reactivationPendingStorageId);
	SessionStorage.remove(constants.dismissedLimitedAccessModal);
}

function invalidateAuthSessions() {
	// remove existing login token and sso from users cookies
	Cookies.expire(constants.cookieSsoId);
	Cookies.expire(constants.cookieSsoCreated);
	Cookies.expire(constants.cookieAemToken);
	Cookies.expire(constants.cookieLtAuthorization);
	Cookies.expire(constants.cookieLtAuthorizationV2);
}

var returnVal = {
	invalidateSessions: invalidateSessions,
	invalidateAuthSessions: invalidateAuthSessions,
	isFeatureFlagEnabled: isFeatureFlagEnabled,
	setCorrectSsoIdProp: setCorrectSsoIdProp
};

export default returnVal;
